import { Draggable } from './Draggable'
import { getValueFromJsonExample } from './Functions'

const renderJsonKeyOrFixedValue = (item, standardHeight) => {
  if (!item.jsonKey && !item.fixedValue) return null
  return item.jsonKey ? getValueFromJsonExample(item.jsonKey) : item.fixedValue
}

export const DraggableLabel = ({ listState: [elements, setElements], pageNumber, parentRef, pdfDimensions }) => {
  const updateElementAddedSignDate = (id, update) => setElements(elements.map((el = {}) => id === el.id ? { ...el, ...update } : el))
  return elements?.filter(item => item.page === pageNumber).map((item, ind) => {
    const standardHeight = item.jsonKey || item.fixedValue || item.date || item?.elements?.length ? 21 : parseInt(item?.height) || 100
    return (
      <Draggable
        key={item.id}
        refParentDiv={parentRef}
        startX={item.coefficientX * pdfDimensions.width}
        startY={item.coefficientY * pdfDimensions.height - standardHeight}
        dimensionContainer={{ height: standardHeight }}
        callbackUpdatePosition={(x, y) => {
          const elaboratedX = x - 20 * 2
          const elaboratedY = (y - 85 * 2) + standardHeight
          updateElementAddedSignDate(item.id, { coefficientX: elaboratedX / pdfDimensions.width, coefficientY: elaboratedY / pdfDimensions.height })
        }}
      >
        <div style={{ color: 'black', fontSize: 10, position: 'absolute', top: -10, left: 0, width: 150 }}>
          {item.id}
        </div>
        <div
          style={{
            border: '1px solid red',
            color: 'black',
            height: standardHeight,
            fontSize: 10,
            sflex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'Arial',
            whiteSpace: 'pre-wrap'
          }}
        >
          {item?.elements?.map((el, ind) =>
            <div style={{ ...(el?.letterSpacing ? { letterSpacing: parseFloat(el?.letterSpacing) || 0 } : {}) }} key={ind}>
              {renderJsonKeyOrFixedValue(el, standardHeight)}
            </div>
          )}
          <div style={{ ...(item?.letterSpacing ? { letterSpacing: parseFloat(item?.letterSpacing) || 0 } : {}) }}>
            {renderJsonKeyOrFixedValue(item, standardHeight)}
          </div>
        </div>
        {item.documentUrl && <img src={item.documentUrl} style={{ height: standardHeight, border: '1px solid red' }} alt='img' />}
        {item.date &&
          <div style={{ border: '1px solid red', color: 'black', height: standardHeight, fontSize: 10, flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', letterSpacing: parseFloat(item?.letterSpacing) || 0, fontFamily: 'Arial' }}>
            {new Date().toLocaleDateString()}
          </div>}
      </Draggable>
    )
  })
}
